import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-aggiungi-voucher-backoffice',
  templateUrl: './aggiungi-voucher-backoffice.component.html',
  styleUrl: './aggiungi-voucher-backoffice.component.css'
})
export class AggiungiVoucherBackofficeComponent {
  
  constructor(private apiService: ApiService, private router: Router, private datePipe: DatePipe) { }  

  formVoucher!: FormGroup;  

  minDate: Date | undefined = new Date();

  ngOnInit(): void {    

    this.formVoucher = new FormGroup({
      cliente: new FormControl(null, Validators.required),      
      email: new FormControl(null, Validators.email),      
      telefono: new FormControl(null),
      codice: new FormControl(null, Validators.required),
      credito: new FormControl(null, Validators.required),
      data_scadenza: new FormControl(null),
    })

  }
  onSubmit() {

    const voucher = {
      cliente: this.formVoucher.get('cliente')?.value,
      email: this.formVoucher.get('email')?.value,
      telefono: this.formVoucher.get('telefono')?.value,      
      credito: this.formVoucher.get('credito')?.value,
      codice: this.formVoucher.get('codice')?.value,
      data_scadenza: this.datePipe.transform(this.formVoucher.get('data_scadenza')?.value, 'yyyy-MM-dd'),
    }

    this.apiService.addVoucher(voucher).subscribe({
      next: (data) => this.apiService.setVouchers(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/vouchers'])
        this.apiService.message('success', 'Aggiunta', "Voucher aggiunto con successo!")
      }
    })

  }
  
}